import request from "../utils/request";

export function getDownUrl(token, password) {
    return request.post("game-down/down-game-url", {token, password});
}